<template>
  <v-card>

    <!-- MAIN CONTENT -->
    <div>

      <!-- main toolbar -->
      <div>
        <v-layout align-center pl-4 pr-2 style="min-height: 56px;">

          <transition
          name="slide-x-reverse-transition"
          mode="out-in">

            <!-- ITEMS -->
            <div 
            v-if="selectedCount === 0"
            key="1"
            class="c-flex-r align-center subheading">

              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

            </div>

            <!-- selected count -->
            <div v-if="selectedCount > 0"
            key="2"
            class="c-flex-r align-center subheading">
              <v-btn
              icon
              class=""
              @click="selected = {}">
                <v-icon>close</v-icon>
              </v-btn>
              <div class="font-weight-bold">
                <span>&nbsp;{{ selectedCount }}</span>
                selected 
              </div>
              <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
              <span class="ml-2">|</span>
              <v-btn 
              icon
              @click="onDelete">
                <v-icon>delete_outline</v-icon>
              </v-btn>
              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectNone">
                    <v-list-item-title>Select none</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

          </transition>

          <v-spacer></v-spacer>

          <div>
            <transition
            name="fade-transition"
            mode="out-in">
              <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
                <span class="grey--text caption">LOADING...</span>&nbsp;
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-layout>
              <div v-else key="L2"></div>
            </transition>
          </div>

        </v-layout>
      </div>
      <!-- !main toolbar -->

      <div>

        <table class="final-table th-no-padding full-width lines-b">
          <colgroup ref="colgroup1">
            <col width="15px">
            <col width="30px">
            <col width="15px">
          </colgroup>

          <tr class="unselectable">

            <c-table-header
            title="Production ID"
            code="id"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Items"
            code="items"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Date"
            code="date"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

          </tr>
          <tr class="unselectable">
            <td>
              <v-text-field
              v-model="filters.search.id"
              solo
              prepend-inner-icon="search"
              placeholder="Search..."
              class="crx-box-input"
              hide-details
              clearable>
              </v-text-field>
            </td>
            <td>
            </td>
            <td>
            </td>
          </tr>
        </table>

        <!-- secondary header (simple pagination and item count) -->
        <v-layout class="align-center border-b--thin">
          <div class="pa-4 label">
            {{ pagination.rowCount }} items
          </div>

          <v-spacer></v-spacer>

          <div class="mr-4">

            <v-tooltip top open-delay="500">
              <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                small
                :disabled="page <= 0"
                @click="goToPreviousPage()"
                class=""
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span>Previous page</span>
            </v-tooltip>

            <v-tooltip top open-delay="500">
              <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                small
                :disabled="page >= pagination.pages - 1"
                @click="goToNextPage()"
                class=""
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <span>Next page</span>
            </v-tooltip>

          </div>
        </v-layout>
        <!-- !secondary header (simple pagination and item count) -->
          
        <list-row
        v-for="item in items" 
        :key="item.id"
        :item="item"
        :itemsMeta="itemsMeta"
        :selected="selected"
        :searchFilters="filters.search"
        @checkRow="checkRow(item)"
        @click.native="clickRow(item)"
        ></list-row>

        <!-- No qued productions -->
        <v-card 
        v-if="items.length === 0"
        class="pa-2 ma-4 subheading elevation-0" >
          <v-layout align-center>
            <img src="@/assets/img/illustrations/production.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  0 qued productions
                </span>
                <v-icon large color="green accent-4">check</v-icon>
              </v-layout>

              <div class="caption text--text text--darken-1">
                Qued productions will be listed here
              </div>
            </div>
          </v-layout>
        </v-card>

        <!-- BOTTOM TOOLBAR -->
        <v-layout align-center class="border-t--thin">
          <!-- PAGINATION -->
          <c-pagination
          :page="page"
          :pagination="pagination"
          :filters="filters"
          @updatePageNumber="updatePageNumber"
          @goToFirstPage="goToFirstPage"
          @goToPreviousPage="goToPreviousPage"
          @goToNextPage="goToNextPage"
          @goToLastPage="goToLastPage"
          ></c-pagination>
          <!-- PAGINATION -->
        </v-layout>
        <!-- !BOTTOM TOOLBAR -->

      </div>


    </div>
    <!-- END MAIN CONTENT -->

  </v-card>
</template>

<script>
import axios from 'axios'
import ListRow from './components/ProductionListRow'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import CTableHeader from '@/components/list-server/th'

export default {
  components: {
    ListRow,
    CTableHeader
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 5,
        sortCol: 'id',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          batch: '',
          production: ''
        },
        active: {
          customer: false,
          date: false
        },
        categories: []
      },
      itemsMeta: {
        newID: null // this will be set to the newst created row
      },
      isLoading: false
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push(`/production/${item.id}`)
      }
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' production' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'This action is permanent. Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('productions/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.page = 0
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    debounceLoad: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/productions?filters=${encodedFilters}&stage=${1}&page=${this.page}`)
        ])
        .then(axios.spread((response) => {
          var hrend = response.data.execution_time
          var rows = response.data.rows
          this.pagination.rowCount = response.data.count
          this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
          this.items = rows
        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
    loadAPI () {
      return this.debounceLoad()
    }
  },
  created () {
    this.loadAPI()
  },
  activated () {
    this.loadAPI()
  },
  /* watch: {
    '$route' (to, from) {
      this.loadAPI()
    }
  } */
}
</script>

<style scoped lang="scss">
.sticky-header {
  position: sticky;
  top: 0;
  background: var(--v-background-base);
  z-index: 1;
  border-bottom: 1px solid var(--v-hline-base);
}
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
.sort-header {
  display: flex;
  align-items: center;
  padding: 8px 4px;
  cursor: pointer;
}
</style>

